import { createSlice } from '@reduxjs/toolkit'

export const selfConstructSlice = createSlice({
  name: 'selfConstruct',
  // active null 尚未知道模式，true 為自建單模式，false 為非自建單模式
  initialState: { active: null },
  reducers: {
    setSelfConstructActive: (state, action) => {
      state.active = action.payload
    },
    setReservationCode: (state, action) => {
      state.reservationCode = action.payload
    },
    setReservationId: (state, action) => {
      state.reservationId = action.payload
    },
    setSelfConstructUserId: (state, action) => {
      state.scUserId = action.payload
    },
    setUserId: (state, action) => {
      state.userId = action.payload
    },
    setSinyiStaffNumber: (state, action) => {
      state.staffNumber = action.payload
    },
    setServiceClfId: (state, action) => {
      state.serviceClfId = action.payload
    },
  },
})

export const selectSelfConstruct = (state) => state.selfConstruct

export const {
  setSelfConstructActive,
  setReservationCode,
  setReservationId,
  setSelfConstructUserId,
  setUserId,
  setSinyiStaffNumber,
  setServiceClfId,
} = selfConstructSlice.actions

export default selfConstructSlice.reducer
